import { render, staticRenderFns } from "./KycPersonalDetails.vue?vue&type=template&id=318c3682&scoped=true&"
import script from "./KycPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./KycPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./KycPersonalDetails.vue?vue&type=style&index=0&id=318c3682&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c3682",
  null
  
)

export default component.exports